<div class="app-shell">
  <header class="app-topbar">
    <div class="app-topbar-inner">
        <!-- Hamburger button - mobile only -->
        <button
          class="app-hamburger-btn"
          (click)="toggleMobileMenu()"
          [attr.aria-expanded]="isMenuOpen()"
          aria-label="Toggle navigation menu"
        >
          <span class="app-hamburger-line"></span>
          <span class="app-hamburger-line"></span>
          <span class="app-hamburger-line"></span>
        </button>


      <a class="app-brand" [routerLink]="['/home']">
        <span class="app-brand-mark">Adventurer's Ledger</span>
        <h1 class="app-brand-title">Character Codex</h1>
        <span class="app-brand-subtitle">Worldbuilding, sessions, and party records</span>
      </a>

      <div class="app-nav-shell">

        <!-- Mobile menu panel -->
        <div class="app-mobile-menu" [class.is-open]="isMenuOpen()">
          <nav class="app-nav">
            <a [routerLink]="['/home']" (click)="closeMobileMenu()">Home</a>

            @if (auth.hasRole(userRole.Admin)) {
              <a [routerLink]="['/users']" (click)="closeMobileMenu()">Users</a>
            }

            @if (auth.hasRole(userRole.DungeonMaster)) {
              <a [routerLink]="['/sessions']" (click)="closeMobileMenu()">Sessions</a>
              <a [routerLink]="['/universes']" (click)="closeMobileMenu()">Universes</a>
            }

            @if (auth.hasRole(userRole.Player)) {
              <a [routerLink]="['/sessions']" (click)="closeMobileMenu()">Sessions</a>
              <a [routerLink]="['/characters']" (click)="closeMobileMenu()">Characters</a>
            }
            <a [routerLink]="['/about']" (click)="closeMobileMenu()">About</a>
          </nav>

          <div class="app-button-container-mobile">
            @if (auth.isLoggedIn()) {
              <a
                class="app-login-btn"
                href=""
                (click)="$event.preventDefault(); logout(); closeMobileMenu()"
                >Logout</a
              >
            } @else {
              <a class="app-login-btn" [routerLink]="['/login']" (click)="closeMobileMenu()"
                >Login</a
              >
            }
          </div>
        </div>

        <!-- Mobile menu backdrop -->
        @if (isMenuOpen()) {
          <div class="app-menu-backdrop" (click)="closeMobileMenu()"></div>
        }

        <!-- Desktop nav -->
        <nav class="app-nav-desktop">
          <a [routerLink]="['/home']">Home</a>

          @if (auth.hasRole(userRole.Admin)) {
            <a [routerLink]="['/users']">Users</a>
          }

          @if (auth.hasRole(userRole.DungeonMaster)) {
            <a [routerLink]="['/sessions']">Sessions</a>
            <a [routerLink]="['/universes']">Universes</a>
          }

          @if (auth.hasRole(userRole.Player)) {
            <a [routerLink]="['/sessions']">Sessions</a>
            <a [routerLink]="['/characters']">Characters</a>
          }
          <a [routerLink]="['/about']">About</a>
        </nav>
      </div>
      <!-- Desktop version: Button area -->
      <div class="app-button-container-desktop">
        @if (auth.isLoggedIn()) {
          <div class="app-user-menu">
            @if (canSwitchRoles()) {
              <button
                type="button"
                class="app-user-badge app-user-badge-btn"
                (click)="toggleRoleSwitcher()"
              >
                {{ auth.currentUser()?.name ?? auth.authenticatedUser()?.name }}
                <span class="app-user-role">
                  {{ getRoleLabel(auth.currentRole()) }}
                </span>
              </button>

              @if (isRoleSwitcherOpen()) {
                <div class="app-role-switcher">
                  <div class="app-role-switcher-title">Enter As</div>

                  @for (role of auth.availableRoles(); track role) {
                    <button
                      type="button"
                      class="app-role-option"
                      [class.is-active]="auth.currentRole() === role"
                      (click)="switchRole(role)"
                    >
                      {{ getRoleLabel(role) }}
                    </button>
                  }
                </div>
              }
            } @else {
              <span class="app-user-badge">
                <span class="app-user-role">
                  {{ auth.currentUser()?.name ?? auth.authenticatedUser()?.name }}
                  {{ getRoleLabel(auth.currentRole()) }}
                </span>
              </span>
            }
          </div>
          <a href="" (click)="$event.preventDefault(); logout()">Logout</a>
        } @else {
          <a class="app-login-btn" [routerLink]="['/login']">Login</a>
        }
      </div>
      <!-- Mobile version: Icon area - positioned at top right -->
      <div class="app-icon-container">
        @if (auth.isLoggedIn()) {
          <button
            type="button"
            class="app-user-icon-btn"
            (click)="toggleRoleSwitcher()"
            [attr.aria-label]="
              'User profile for ' + (auth.currentUser()?.name ?? auth.authenticatedUser()?.name)
            "
          >
            <svg class="app-user-icon" viewBox="0 0 24 24" aria-hidden="true">
              <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="2" />
              <circle cx="12" cy="8" r="3" fill="none" stroke="currentColor" stroke-width="2" />
              <path
                d="M 12 14 C 9.791 14 8 15.791 8 18 L 16 18 C 16 15.791 14.209 14 12 14 Z"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              />
            </svg>
          </button>

          @if (isRoleSwitcherOpen()) {
            <div class="app-role-switcher app-role-switcher-mobile">
              <div class="app-role-switcher-title">Enter As</div>

              @for (role of auth.availableRoles(); track role) {
                <button
                  type="button"
                  class="app-role-option"
                  [class.is-active]="auth.currentRole() === role"
                  (click)="switchRole(role)"
                >
                  {{ getRoleLabel(role) }}
                </button>
              }

              <div class="app-role-switcher-divider"></div>
              <button type="button" class="app-logout-option" (click)="logout()">Logout</button>
            </div>
          }
        } @else {
          <a class="app-login-icon-btn" [routerLink]="['/login']" aria-label="Login">
            <svg class="app-login-icon" viewBox="0 0 24 24" aria-hidden="true">
              <path
                d="M 3 12 L 15 12"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
              />
              <path
                d="M 12 9 L 15 12 L 12 15"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M 17 5 L 20 5 C 21.1 5 22 5.9 22 7 L 22 17 C 22 18.1 21.1 19 20 19 L 17 19"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
          </a>
        }
      </div>
    </div>
  </header>

  <main class="app-main">
    <router-outlet></router-outlet>
  </main>

  @if (shouldShowRoleSelectionModal()) {
    <div class="app-role-modal-overlay">
      <section
        class="app-role-modal"
        aria-modal="true"
        role="dialog"
        aria-labelledby="role-entry-title"
      >
        <div class="section-kicker">Choose Your Path</div>
        <h2 id="role-entry-title" class="section-title">Enter The Codex As</h2>

        <div class="app-role-modal-actions">
          @for (role of auth.availableRoles(); track role) {
            <button type="button" class="secondary-btn" (click)="selectEntryRole(role)">
              {{ getRoleLabel(role) }}
            </button>
          }
        </div>
        <p class="empty-copy">
          Choose the role you want to use for this visit. Navigation and route access will follow
          this choice until you switch roles or log out.
        </p>
      </section>
    </div>
  }
</div>
